import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import { Input, Select } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

const API_TAB = 'family'

// Данные для дропдаунов
const relationTypes = [
  { name: '', value: '' },
  { name: 'Отец', value: 'father' },
  { name: 'Мать', value: 'mother' },
  { name: 'Супруг', value: 'husband' },
  { name: 'Супруга', value: 'wife' },
  { name: 'Сын', value: 'son' },
  { name: 'Дочь', value: 'daughter' },
  { name: 'Брат', value: 'brother' },
  { name: 'Сестра', value: 'sister' },
  { name: 'Дедушка', value: 'grandfather' },
  { name: 'Бабушка', value: 'grandmother' }
]

export default function Family() {
  const { allForms, trackDeletion } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { family: apiFamily } = personTabData || {}

  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    patronymic: '',
    relation: '',
    birthDate: '',
    workplace: '',
    address: ''
  })

  const [selectedRow, setSelectedRow] = useState(null)

  // Данные таблицы берем из Formik
  const tableData = values.family || []

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiFamily && !tableData.length) {
      setFieldValue('family', apiFamily)
    }
  }, [apiFamily, tableData.length, setFieldValue])

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  const handleAddRow = () => {
    const newRow = {
      id: `new_${Date.now()}`,
      lastname: formData.lastName,
      firstname: formData.firstName,
      patronymic: formData.patronymic,
      relation_type: formData.relation,
      birth_date: formData.birthDate,
      workplace: formData.workplace,
      address: formData.address
    }
    // Сохраняем в Formik
    setFieldValue('family', [...tableData, newRow])
  }

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const rowToDelete = tableData.find(row => (row.id || row.xp_key) === selectedRow)
      if (rowToDelete) {
        const pk = rowToDelete.xp_key || rowToDelete.id || rowToDelete.xp_fm_id
        if (pk && !String(pk).startsWith('new_')) {
          trackDeletion(API_TAB, pk)
        }
      }
      // Обновляем в Formik
      const updatedData = tableData.filter(row => (row.id || row.xp_key) !== selectedRow)
      setFieldValue('family', updatedData)
      setSelectedRow(null)
    }
  }

  const renderOptions = ({ name, value }) => (
    <option key={value || 'empty'} value={value}>{name}</option>
  )

  return (
    <div className={styles.tabWrapper}>
      {/* Форма */}
      <div className={styles.qualificationForm}>
        {/* Строка 1 */}
        <div className={styles.inputsRow}>
          <Input
            label="Фамилия"
            name="lastName"
            value={formData.lastName}
            onChange={handleFormChange}
          />
          <Input
            label="Имя"
            name="firstName"
            value={formData.firstName}
            onChange={handleFormChange}
          />
          <Input
            label="Отчество"
            name="patronymic"
            value={formData.patronymic}
            onChange={handleFormChange}
          />
        </div>

        {/* Строка 2 */}
        <div className={styles.inputsRow}>
          <Select
            label="Тип родства"
            name="relation"
            value={formData.relation}
            onChange={handleFormChange}
          >
            {relationTypes.map(renderOptions)}
          </Select>
          <Input
            label="Дата рождения"
            type="date"
            name="birthDate"
            value={formData.birthDate}
            onChange={handleFormChange}
          />
        </div>

        {/* Строка 3 */}
        <div className={styles.inputsRow}>
          <Input
            label="Место работы / учебы"
            name="workplace"
            value={formData.workplace}
            onChange={handleFormChange}
          />
          <Input
            label="Адрес проживания"
            name="address"
            value={formData.address}
            onChange={handleFormChange}
          />
        </div>

        {/* Кнопки */}
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={handleAddRow}>+ Добавить строку</Button>
            <Button mode="delete" onClick={handleDeleteRow}>× Удалить строку</Button>
          </div>
        </div>
      </div>

      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Фамилия И.О.</th>
              <th>Тип родства</th>
              <th>Дата рождения</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map(row => {
                const rowId = row.id || row.xp_key
                const fio = row.shortName || `${row.lastname || ''} ${row.firstname?.[0] || ''}.${row.patronymic?.[0] || ''}.`.trim()
                return (
                  <tr
                    key={rowId}
                    onClick={() => handleRowSelect(rowId)}
                    className={selectedRow === rowId ? styles.selectedRow : ''}
                  >
                    <td>{fio}</td>
                    <td>{row.relation_type || row.relation}</td>
                    <td>{row.birth_date || row.birthDate}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="3" className={styles.emptyTable}>
                  Нет данных о составе семьи
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
